export class QuickQuoteSession {
    constructor(opportunityId, sessionId, fxbuyflowsessionId, accessToken, agentId) {
        this.opportunityId = opportunityId;
        this.sessionId = sessionId;
        this.fxbuyflowsessionId = fxbuyflowsessionId;
        this.accessToken = accessToken;
        this.agentId = agentId;
    }
}